export const payTable: any = {
  1: {
    1: 3.5,
  },
  2: {
    1: 1,
    2: 10,
  },
  3: {
    2: 2,
    3: 50,
  },
  4: {
    2: 1.5,
    3: 10,
    4: 80,
  },
  5: {
    2: 1,
    3: 3,
    4: 30,
    5: 150,
  },
  6: {
    3: 2,
    4: 15,
    5: 70,
    6: 500,
  },
  7: {
    0: 1,
    3: 2,
    4: 5,
    5: 20,
    6: 80,
    7: 1000,
  },
  8: {
    0: 1,
    4: 5,
    5: 15,
    6: 60,
    7: 200,
    8: 2000,
  },
  9: {
    0: 2,
    4: 2,
    5: 10,
    6: 25,
    7: 150,
    8: 2000,
    9: 5000,
  },
  10: {
    0: 3,
    5: 5,
    6: 20,
    7: 100,
    8: 500,
    9: 2000,
    10: 10000,
  }
};
